@import '~style-sheet-helpers/core.less';

.country-dropdown {
  color: inherit;
}
